import firebase from 'firebase/app'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    status: ""
  },
  mutations: {},
  actions: {
    login({ dispatch }, { email, password }) {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(() => {
          dispatch('user/getPageLimit', {}, { root: true })
          router.push('/companies-list')
        })
        .catch(() => {
          alert("Email or password is invalid.")
        })
    },
    signInWithToken({ dispatch }, { token }) {
      firebase
        .auth()
        .signInWithCustomToken(token)
        .then(() => {
          dispatch('user/getPageLimit', {}, { root: true })
          router.push('/companies-list')
        })
        .catch((err) => {
          alert('Sign in with token ' + err)
        })
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          if(router.currentRoute.name === "Login"){
            window.location.reload()
          }else router.push('/login')
        })
        .catch(() => {
          alert("error")
        })
    },
    logoutWithoutRedirect() {
      firebase
        .auth()
        .signOut()
        .then(() => {
        })
        .catch(() => {
          alert("error")
        })
    }
  },
  modules: {}
}
